import { render, staticRenderFns } from "./AddSpaceModal.vue?vue&type=template&id=3641d4f1&scoped=true&"
import script from "./AddSpaceModal.vue?vue&type=script&lang=js&"
export * from "./AddSpaceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddSpaceModal.vue?vue&type=style&index=0&id=3641d4f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641d4f1",
  null
  
)

export default component.exports